// Solar calculator engine - ported from backend
export const calculateSolarSavings = (monthlyBill, systemSizeInput = null) => {
  const avg_cost_per_unit = 8;
  const monthly_units = monthlyBill / avg_cost_per_unit;

  let system_size_kw;
  if (systemSizeInput) {
    system_size_kw = systemSizeInput;
  } else {
    system_size_kw = (monthly_units * 12) / (365 * 4);
  }
  system_size_kw = Math.round(system_size_kw * 100) / 100;

  // Cap maximum recommended system size at 10 kW
  if (system_size_kw > 10) {
    system_size_kw = 10;
  }

  // System cost lookup table (from provided pricing)
  const costTable = {
    1: 83000,
    2: 144000,
    3: 206400,
    4: 259600,
    5: 324500,
    6: 389400,
    7: 454300,
    8: 519200,
    9: 584100,
    10: 649000
  };

  // Round system size to nearest integer for cost lookup
  const systemSizeRounded = Math.round(system_size_kw);
  const total_cost = costTable[systemSizeRounded] || (systemSizeRounded * 65000); // fallback for sizes > 10

  // Government subsidy based on system capacity (from MNRE table)
  let govt_subsidy = 0;
  if (systemSizeRounded === 1) {
    govt_subsidy = 30000;
  } else if (systemSizeRounded === 2) {
    govt_subsidy = 60000;
  } else if (systemSizeRounded >= 3) {
    govt_subsidy = 78000;
  }

  // Fixed charges
  const discom_feasibility_charges = 2950;
  const mnre_subsidy_application_charges = 1770;
  const total_charges = discom_feasibility_charges + mnre_subsidy_application_charges;

  // Calculate effective cost after subsidy and charges
  const effective_cost_after_subsidy = total_cost - govt_subsidy + total_charges;
  const net_cost = effective_cost_after_subsidy;

  const monthly_savings = monthlyBill * 0.8;
  const yearly_savings = monthly_savings * 12;

  const payback_period =
    yearly_savings > 0 ? Math.round((net_cost / yearly_savings) * 10) / 10 : 0;

  return {
    system_size_kw,
    monthly_savings: Math.round(monthly_savings * 100) / 100,
    yearly_savings: Math.round(yearly_savings * 100) / 100,
    payback_period,
    total_cost: Math.round(total_cost * 100) / 100,
    govt_subsidy: Math.round(govt_subsidy * 100) / 100,
    discom_feasibility_charges: Math.round(discom_feasibility_charges * 100) / 100,
    mnre_subsidy_application_charges: Math.round(mnre_subsidy_application_charges * 100) / 100,
    total_charges: Math.round(total_charges * 100) / 100,
    net_cost: Math.round(net_cost * 100) / 100
  };
};
